import { useQuery } from "@tanstack/react-query";
import { Skeleton, Spin, Typography } from "antd";
import type { components } from "@entities/journal";
import {
  generateTitleName,
  getResponsibleQuery,
  getSignersQuery,
} from "./model";
import type { SettingsCardProps } from "./model";
import { SettingsCardPart } from "./ui";

const SettingsCard = ({ section, parts, id }: SettingsCardProps) => {
  const query = getSignersQuery({
    titleId: id,
    type: section,
    sectionOneId: id,
    sectionTwoId: id,
    sectionThreeId: id,
    sectionFourId: id,
    sectionSixId: id,
  });

  // @ts-expect-error union query options по типу раздела журнала
  const { data: signersList } = useQuery(query);

  const {
    data: responsibleList,
    isLoading,
    isFetching,
    // @ts-expect-error union query options по типу раздела журнала
  } = useQuery(getResponsibleQuery(section, id));

  if (isLoading)
    return (
      <Skeleton.Node
        style={{ width: "100%", height: "158px", borderRadius: "16px" }}
        active
      />
    );

  return (
    <div className="table-container table-container-custom">
      <Typography.Title
        level={4}
        style={{
          marginBottom: "0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {generateTitleName(section)} {isFetching && <Spin size="default" />}
      </Typography.Title>

      {parts.map((part) => (
        <SettingsCardPart
          key={part}
          part={part}
          userList={
            responsibleList?.[part as keyof typeof responsibleList] ?? []
          }
          id={id}
          section={section}
          singersList={
            section === "title" || section === "section-six"
              ? []
              : (signersList as components["schemas"]["SignersInfo"] | undefined)
                  ?.signers
          }
        />
      ))}
    </div>
  );
};

export default SettingsCard;
